import React from "react";
import { connect } from "react-redux";
import { deleteFAQ, getFAQs } from "../dashboard/actions";
import "./style.scss";

const FaqList = () => {
  return (
    <>
      <div className="blackListArea"></div>
    </>
  );
};
const mapStateToProps = (state) => ({
  faqs: state.admin.faqs,
});
export default connect(mapStateToProps, {
  getFAQs,
  deleteFAQ,
})(FaqList);
